import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Conciliação Bancária",
  path: "/prestacaocontas/pcoconciliacaobancaria",
  name: "pcoconciliacaobancaria",
  component: () => import("@/views/prestacaocontas/pcoconciliacaobancaria/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.CONCILIACAOBANCARIANOVO_MENU_1500100399],
  },
  goesToMenu: true,
 },
]
